 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"b5e66463f0d78afc1b20d319c225e1cac0c10526","3":"2ffee158c2abe8f501180060fa6e5281565138de","4":"5a24e9af28afb697c86560c471aa7558c0e4159f","5":"afdf4ac36537cfa7f59a2496499882af829ab3eb","6":"686a05e1d4c64afddbb40ff81356b138f2bda482","7":"b399a733c9f77fd57a6a5a5122992f9f303458f1","8":"ab0aeaba9d9f8403aa9a6a5f511c3de5596eff30","9":"b925d08e0896fc99460a62a39370117a394a5018","10":"component---src-pages-strefa-nauczyciela-konkurs-potwierdzenie-js","11":"component---src-pages-strefa-nauczyciela-konkurs-zgloszenie-klasy-js","12":"d85a63a445b15affb6eec76a1b89472fc979402e","13":"ee1041291cb70d55d0d2e8cabcab30d07990f11e","16":"component---src-pages-404-js","17":"component---src-pages-ekwipunek-samodzielniaka-js","18":"component---src-pages-index-js","19":"component---src-pages-quiz-index-js","20":"component---src-pages-slownik-js","21":"component---src-pages-strefa-dziecka-js","22":"component---src-pages-strefa-nauczyciela-index-js","23":"component---src-pages-strefa-nauczyciela-konkurs-index-js","24":"component---src-pages-strefa-nauczyciela-konkurs-materialy-js","25":"component---src-pages-strefa-nauczyciela-konkurs-zgloszenie-pracy-js","26":"component---src-pages-strefa-rodzica-7-stereotypow-na-temat-pieniedzy-js","27":"component---src-pages-strefa-rodzica-baza-wiedzy-js","28":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-aleksander-naganowski-js","29":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-js","30":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-maciej-samcik-js","31":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-monika-sajkowska-js","32":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-natalia-tur-js","33":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-tatiana-mindewicz-puacz-js","34":"component---src-pages-strefa-rodzica-index-js","35":"component---src-pages-strefa-rodzica-jak-budowac-postawe-odpowiedzialnosci-finansowej-js","36":"component---src-pages-strefa-rodzica-jak-ustalic-wysokosc-kieszonkowego-js","37":"component---src-pages-strefa-rodzica-jak-wdrazac-dzieci-w-prowadzenie-doroslego-domowego-budzetu-js","38":"component---src-pages-strefa-rodzica-kieszonkowe-js","39":"component---src-pages-strefa-rodzica-mamo-kup-mi-jak-reagowac-na-dzieciece-prosby-js","40":"component---src-pages-strefa-rodzica-quiz-index-js","41":"component---src-pages-strefa-rodzica-roznice-finansowe-w-klasie-js","42":"component---src-pages-strefa-rodzica-twoje-dziecko-mysli-ze-kieszonkowe-spada-z-nieba-js","43":"component---src-pages-strefa-rodzica-tysiak-js"}[chunkId]||chunkId) + "-" + {"0":"0d77ca7d24d1d40bcca2","1":"e9d24b1846c7d6eb9685","2":"1993c06d11ed867f7748","3":"eac65bf975eb0eae9ebb","4":"aa7fea0e2c8046a0b80c","5":"b899065c8f10a40dc1e9","6":"dc7a4723edb4da428048","7":"d4582503d34eacbf8633","8":"c20f7c86a087d1a371af","9":"46afb1e87baa1b111942","10":"909785642873b7687400","11":"43b54b748026782c6c78","12":"00b700eda8d89027a1d0","13":"72ae5063dd3a4a945469","16":"9dc9aef4604bf34ad994","17":"36df101a2b186c7eaffc","18":"9807fe7689065c1b84d7","19":"ebd0221f61b9cd4e3a9a","20":"4f366e42410ffc74e97b","21":"0edd8844fafbe39c821b","22":"61063d8d915acdb56c13","23":"c11dc8b602fee661ad5f","24":"8786e2c7715122de825e","25":"d52c4d74594ffaa7c205","26":"8f0656450baaf4ca74a0","27":"ba299979eff39330c5e6","28":"dc924b045d03c1519ab7","29":"4373421f29c39bade8ff","30":"a25389c8e55f696ab871","31":"4d84a31b9ae0083b4d38","32":"aef46c808ad03c98edea","33":"0d89f7062958aadd729e","34":"3f040adb5bc69a97f443","35":"60fc2f4614989ffde4f5","36":"bf3b5966f2d92535bb07","37":"b01d29c0f732d163a03f","38":"5280c383e054f89aa3ab","39":"daa5d475f168c0d13c02","40":"7743c8cb89efbc262b48","41":"f3271b97554a0cbfaf87","42":"1a43cd865f7a3e570279","43":"d7c4d7c85b21da23a093"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"b5e66463f0d78afc1b20d319c225e1cac0c10526","3":"2ffee158c2abe8f501180060fa6e5281565138de","4":"5a24e9af28afb697c86560c471aa7558c0e4159f","5":"afdf4ac36537cfa7f59a2496499882af829ab3eb","6":"686a05e1d4c64afddbb40ff81356b138f2bda482","7":"b399a733c9f77fd57a6a5a5122992f9f303458f1","8":"ab0aeaba9d9f8403aa9a6a5f511c3de5596eff30","9":"b925d08e0896fc99460a62a39370117a394a5018","10":"component---src-pages-strefa-nauczyciela-konkurs-potwierdzenie-js","11":"component---src-pages-strefa-nauczyciela-konkurs-zgloszenie-klasy-js","12":"d85a63a445b15affb6eec76a1b89472fc979402e","13":"ee1041291cb70d55d0d2e8cabcab30d07990f11e","16":"component---src-pages-404-js","17":"component---src-pages-ekwipunek-samodzielniaka-js","18":"component---src-pages-index-js","19":"component---src-pages-quiz-index-js","20":"component---src-pages-slownik-js","21":"component---src-pages-strefa-dziecka-js","22":"component---src-pages-strefa-nauczyciela-index-js","23":"component---src-pages-strefa-nauczyciela-konkurs-index-js","24":"component---src-pages-strefa-nauczyciela-konkurs-materialy-js","25":"component---src-pages-strefa-nauczyciela-konkurs-zgloszenie-pracy-js","26":"component---src-pages-strefa-rodzica-7-stereotypow-na-temat-pieniedzy-js","27":"component---src-pages-strefa-rodzica-baza-wiedzy-js","28":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-aleksander-naganowski-js","29":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-js","30":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-maciej-samcik-js","31":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-monika-sajkowska-js","32":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-natalia-tur-js","33":"component---src-pages-strefa-rodzica-czy-dawanie-kieszonkowego-sie-oplaca-tatiana-mindewicz-puacz-js","34":"component---src-pages-strefa-rodzica-index-js","35":"component---src-pages-strefa-rodzica-jak-budowac-postawe-odpowiedzialnosci-finansowej-js","36":"component---src-pages-strefa-rodzica-jak-ustalic-wysokosc-kieszonkowego-js","37":"component---src-pages-strefa-rodzica-jak-wdrazac-dzieci-w-prowadzenie-doroslego-domowego-budzetu-js","38":"component---src-pages-strefa-rodzica-kieszonkowe-js","39":"component---src-pages-strefa-rodzica-mamo-kup-mi-jak-reagowac-na-dzieciece-prosby-js","40":"component---src-pages-strefa-rodzica-quiz-index-js","41":"component---src-pages-strefa-rodzica-roznice-finansowe-w-klasie-js","42":"component---src-pages-strefa-rodzica-twoje-dziecko-mysli-ze-kieszonkowe-spada-z-nieba-js","43":"component---src-pages-strefa-rodzica-tysiak-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2b0329026016d96c8737","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
